<app-message-item
  *ngFor="let message of messages; let i = index; trackBy: trackByMessageId"
  [message]="message"
  [filteredMessages]="messages"
  [activeMessageId]="activeMessageId"
  [copiedMessageId]="copiedMessageId"
  [exportedMessageId]="exportedMessageId"
  [isStreaming]="isMessageStreaming(message, i)"
  (copySuccess)="onCopySuccess($event)"
  (exportSuccess)="onExportSuccess($event)"
  (exportError)="onExportError($event)"
  (messageEnter)="onMessageEnter($event)"
  (messageLeave)="onMessageLeave()"
  (messageClick)="onMessageClick($event)"
  (messageMouseDown)="onMessageMouseDown($event)"
  (messageMouseUp)="onMessageMouseUp($event)"
  (deleteFile)="onDeleteFile($event)"
></app-message-item>
